var bxSliders = [];

var sliderShelfOptions = {
	slideWidth: 170,
	minSlides: 5,
	maxSlides: 5,
	slideMargin: 35,
	pager: false,
	preventDefaultSwipeY: false,
	onSliderLoad: function() {
		var stuckLoader = $(".bx-loading");
		if (stuckLoader.length > 0) {
			stuckLoader.hide().siblings(".bx-controls").hide().siblings(".bx-wrapper").unwrap();
		}
	}
};
	
var setSliderNumByWidth = function () {
	var w = $('body').innerWidth();
		switch(true) {
			case (w < 320):
				console.log('very low mobile');
				setSliderNum(1);
				break;
			case (w < 500):
				console.log('very low mobile');
				setSliderNum(2);
				break;
			case (w < 640):
				console.log('mobile');			
				setSliderNum(3);
				break;
			case (w < 800):
				console.log('tablet');			
				setSliderNum(4);
				break;
			case (w < 1080):
				console.log('netbook');			
				setSliderNum(5);
				break;
			case (w < 2000):
				console.log('desktop');			
				setSliderNum(5);
				break;
		}
};
	
	
var setSliderNum = function(num) {
	$.each(bxSliders, function(i,bx) {
		bx.reloadSlider($.extend(sliderShelfOptions, {
			minSlides: num,
			maxSlides:	num
		}));
	});
};
	
$(document).ready(function() {


	if($(document).width() > getMobileWidth()) {
		initFull();
	} else {
		initPhone();
	}
	$(".shelf::after").css("opacity","1");
	attachBasketEvents();
	
	
	var timer;
	
	triggerAfterResizeDelay(function() {
		if($(document).width() > getMobileWidth()) {
			initFull();
		} else {
			initPhone();
		}
		setSliderNumByWidth();
	});
	
	if ($("#article_view_author_article-product-list-widget-author").length > 0) {
		bxSliders.push($("#article_view_author_article-product-list-widget-author .product-list").bxSlider(sliderShelfOptions));
		//setSliderNumByWidth();
	}
	
    // HEADER INFOBOX
    $(".header-infobox").each(function() { 
        var $this = $(this);
        
        $('<span class="close"></span>').appendTo($this).click(function() {
            $this.slideUp();
            sessionStorage.betaWarningAlreadyViewed = "true";
        });
    });
    if (!sessionStorage.betaWarningAlreadyViewed) {
        $(".header-infobox.important").show(); 
    }
    
	basketFancyboxOptions = {
		type: 'ajax',
		maxWidth:1000,
		maxHeight:800
	};
	
	// ARTICLE POPUP AND OTHER FANCYBOXES
	$(".article-popup").fancybox(basketFancyboxOptions);
	$("a.fancybox").fancybox();
	
	// BASKET
	
	
	basketView = $("#basket-view");
	$("#basket-box .close").click(function() { 
		$(this).parent().fadeOut(100);
	});
	
	var viewUrl = cyclone3.domain+"?type=ajax_basket_update #ajax-body";
	
	attachBasketEvents(); // removing from basket and amount spinner
	attachToBasketEvents(); // to basket button
	attachToFavoritesEvents();

	
	$(".newsletter-email-checkbox").tooltip({
		content: function()  {
			return $("#newsletter-agreement-text").html();
		},
		items: "div",
		track: true,
		show: { effect: "fade", duration: 500 },
		hide: { effect: "fade", duration: 500 }
	});
	
	// NEWSLETTER FANCYBOX
	var newsletterForm = $("#newsletter-form");
	var isClicked = false;
	newsletterForm.bind('submit', function (e) {
		var self = $(this);
		
		e.preventDefault(); 
		$('#newsletter-form-success').hide();
		$('#newsletter-form-error').hide();
		var email = $("#newsletter-email-input").val();
		var checkbox = $("#newsletter-input-checkbox").is(':checked');
		if(email!=="" && checkbox) { 
			self.find('button[type=submit]').addClass("loading");
			self.find('button[type=submit]').attr('disabled','disabled');
			$.ajax({
				url: '/json/newsletter_add',
				type: "POST",
				data: {email: email, sended: 1},
				dataType: "json"
			})
			.done(function(data) {
				if(data.success == true) {
					$('#newsletter-form-success').show();
					newsletterForm[0].reset();
				}
				else {
					$('#newsletter-form-error').show();
				}
				self.find('button[type=submit]').removeClass("loading");
				self.find('button[type=submit]').removeAttr('disabled');
			})
			.fail(function() {		
				$('#newsletter-form-error').show();
				self.find('button[type=submit]').removeClass("loading");
				self.find('button[type=submit]').removeAttr('disabled');
			});
		} else {
			if (!isClicked) {
				isClicked = true;
				if (email==="") {
					var origBgColor = self.find('input[type=email]').css("border-color");
					var origColor = self.find('input[type=email]').css("color");
					self.find('input[type=email]').animate(
						{
						"border-color": "red",
						"color": "red"
						}, 250)
						.delay(2000).animate({"border-color": origBgColor, "color": origColor }, function() { isClicked = false });
				}
				if (!checkbox) {
					self.find('.newsletter-email-checkbox').animate(
						{
						"border-color": "red",
						"color": "red"
						}, 250)
						.delay(2000).animate({"border-color": origBgColor, "color": origColor }, function() { isClicked = false });
				}
			}
		}
	});


});


window.onload = function() {
	console.log('is loaded');
	$(".shelf::after").css("opacity","1");
	setSliderNumByWidth();
};

var mobileWidth = 650;
var fullWidth = 940;

function getMobileWidth() {
	return mobileWidth;
}

function getFullWidth() {
	return fullWidth;
}

// RESPONSIVE ELEMENTS INITIALIZATIONS

function initFull() {
	if (typeof snapper !== "undefined") {
		snapper.on('close', function() {
			$("#body").removeAttr('style');	
			snapper.off('close');
		});
		snapper.close();
	}
}

function initProductTooltips() {
	if ($(document).width()>getMobileWidth()) {
		$(".product-list img[rel]").tooltip({
			content: function()  {
				var s = $(this).attr('rel');
				return '<img class="clearfix" src='+s+'>';
			},
			items: "img[rel]",
			track: true,
			show: { effect: "fade", duration: 500 },
			hide: { effect: "fade", duration: 500 }
		});
	} else {
		try {
			$(".product-list img[rel]").tooltip("destroy");
		} catch(e) {
			
		}
	}
}

function initPhone() {
	
	initDrawers();

}

var snapper;
var initDrawers = function() {
	// create drawer menu HTML
	if ($('body > .drawers').length < 1) { 
		var drawers = $('<div class="drawers"><div class="snap-drawer drawer-left"></div><div class="snap-drawer drawer-right"></div></div>').prependTo($('body'));
		$('#body').css({'z-index':2,'position':'absolute','min-height':window.innerHeight });
		drawers.children('.drawer-right').append(
			$('<div class="search"><div class="title">Vyhľadávanie</div></div>')
				.append($('#search').html()),
			$('<nav class="page-list"><div class="title">Menu</div></div>')
				.append($('.header-container .menu-top').html())
        );
		
		// attach spans for +/- for slide menu
		$('<span class="expander"></span>').prependTo($(".drawer-right ul li.type-product_list, .drawer-right ul li.type-product_brand_list").first()).click(function() {
			$(this).parent().toggleClass("open").find("ul").first().slideToggle();
		});
		
		// open items which has to be initially opened 
		$(".drawer-right nav.product-cat-list ul li.open.has-subitems ul").slideToggle();
	}
	
	// attach click to mobile menu button	
	$('#phone-menu').click(function() {
		if( snapper.state().state=="right" ){
			snapper.close();
		} else {
			snapper.open('right');
		}
	});

	// init snapper.js
	
	snapper = new Snap({
		element: document.getElementById('body'),
		disable: 'left',
		touchToDrag: false
	});
};

function triggerAfterResizeDelay(triggerFnc) {
	var timer;
	$(window).bind('resize', function(){
		timer && clearTimeout(timer);
		timer = setTimeout(triggerFnc, 500); 
	});
}

// UTILITIES

function formatPrice(price, suffix, nbsp, floor) {
	
	if (cyclone3.lng == "cz") {
		price = Math.round(10*price)/10;
	}
	
	price = Number(price).toFixed(2);
	if (price == "NaN") {
		return "?";
	}
	if (typeof floor !== "undefined") {
		price = Math.floor(price);
	}
	if (typeof suffix === "undefined") {
		suffix = "";
	}
	var space = "&nbsp;";
	if (typeof nbsp !== "undefined" && !nbsp) {
		space = " ";
	}
	price = String(price).replace('.00',',-');
	var output = String(price).replace('.',',') + space + suffix;
	return output;
}



var attachToBasketEvents = function() {
	console.log('attach to basket');
	$("a.to-basket,button.to-basket").not(".disabled").each(function(i,e) {
		console.log('attaching on',$(this));
		$(e).off();
		$(e).on('click tap', function(event) {
			event.preventDefault();
			addToBasket(event.currentTarget);
		});
	});
};

var addToBasket = function(item) {
	if ((typeof amount === "undefined") || amount.length<0) {
		amount = 1;
		action = "add";
	}
	
	var parentForm = $(item).parents("form").first();
	
	var updateUrl = cyclone3.domain+"?type=ajax_basket_update&added_only=1";
	
	if($(document).width() > getMobileWidth()) {
		
		$.get(updateUrl, parentForm.serialize(), function(data) {
			var url = cyclone3.domain+"?type=ajax_basket_info";
			$('#basket-wrapper').load(url);


			var basketBox = $("#basket-box");
			var basketBoxContent = $("#basket-box-content");
			var content = $("<div></div>").html(data);
			basketBoxContent.html(content.find("div#ajax-body"));
			basketBox.fadeIn();
			
			var timerms = 3000;
			var timer = setInterval(function() {
				onTimer();
			},timerms);
			
			basketBox.mouseenter(function() { clearInterval(timer); });
			basketBox.mouseleave(function() { 
				timer = setInterval(function() {
					onTimer();
				},timerms);
			});
			var onTimer = function() {
				basketBox.fadeOut();
				clearInterval(timer);
			};
		});
		
	} else {
		parentForm.submit();
	}
};

var attachBasketEvents = function() {
	// unbind existing events to prevent duplicity
	$(".remove-from-basket").off();
	$(".amount-spinner > input").off();

		
		    
    $.widget( "ui.spinner", $.ui.spinner, {
        _buttonHtml: function() {
            return "" +
                "<input class='ui-spinner-button ui-spinner-up' id='buttonadd' type='button' value='&plus;' />" +
                "<input class='ui-spinner-button ui-spinner-down' id='buttonremove' type='button' value='&minus;' />";
        }
    }); 
	
	var spinner = $(".amount-spinner > input").spinner({
		min: 1,
		numberFormat: "n"
	});

	
	$(".remove-from-basket").click(function(e) {
		var productID = $(e.currentTarget).data("product-id");
		var deleteUrl = cyclone3.domain+"?type=ajax_basket_update&remove="+productID+" #ajax-body";

		$(basketView).load(deleteUrl,function() {
			attachBasketEvents();
			updateBasketInfo();
		});
	});
	
	//$(".basket-view .amount-spinner input").basketSpinner();
	$(".amount-spinner .ui-spinner > input").on("spin", function(e,ui) { 
		$("#basket-action-loader").show();
		updateBasketAmount($(e.currentTarget).data("product-id"),ui.value);
	});	
};

var attachToFavoritesEvents = function() {
	$(".fav:not(.active)").each(function(i,e) {
		attachAddToFavorites($(e));
	});
	$(".fav.active").each(function(i,e) {
		attachRemoveFromFavorites($(e));
	});
};

var attachAddToFavorites = function(favBtn) {
		favBtn.off();
		favBtn.on('click tap',function(event) {
			var productID = $(event.currentTarget).data("product-id");
			action = "add";
			var updateUrl = cyclone3.domain+"?type=ajax_favorites_update&"+action+"="+productID + " #ajax-body";
				$.get(updateUrl,function() {
					favBtn.addClass("active");
					favBtn.children(".added").show();
					favBtn.children(".add").hide();
					
					attachRemoveFromFavorites(favBtn);
				});			
		});
};

var attachRemoveFromFavorites = function(favBtn) {
	favBtn.off();
	favBtn.click(function(event) {
		var productID = $(event.currentTarget).data("product-id");
		action = "remove";
		var updateUrl = cyclone3.domain+"?type=ajax_favorites_update&"+action+"="+productID + " #ajax-body";
		$.get(updateUrl,function() {
				favBtn.removeClass("active");
				favBtn.children(".add").show();
				favBtn.children(".added").hide();
				favBtn.off();
				
				if (cyclone3.type == "favorites_list") {
					favBtn.parents('.item').fadeOut();
				} else {
					attachAddToFavorites(favBtn);
				}
		});
	});
};

var updateBasketAmount = function(productID,amount) {
	
	var updateUrl = cyclone3.domain+"?type=ajax_basket_update&update_"+productID+"="+amount+" #ajax-body";
	
	$(basketView).load(updateUrl,function() {
		$("#basket-action-loader").hide();
		attachBasketEvents();
		updateBasketInfo();
	});
};

var updateBasketInfo = function() {
	var totalItems = $("#basket-subtotal").data("total-items");
	var totalPrice = $("#basket-subtotal").data("total-price");	

	$("#basket-info-total-items, #basket-phone-total-items").html(totalItems);
	$("#basket-info-total-price, #basket-phone-total-price").html(totalPrice);
};


var showFieldsIfChecked = function(check,fields) {
	if (check.length > 0) {
		if (check.is(":checked")) {
			$(fields).slideDown();
		} else {
			$(fields).slideUp();
		}
	}
};


